import {isNil} from 'ramda';

import {browserStorageKey} from '@dms/config';

import type {AppSyncAuthHeader} from '../types';
import {captureWebsocketError} from './captureWebsocketError';

export const buildAuthHeader = (): AppSyncAuthHeader | null => {
  const accessToken = sessionStorage.getItem(browserStorageKey.ACCESS_TOKEN);
  const appSyncUrl = process.env.APPSYNC_URL;

  if (isNil(accessToken)) {
    console.error('Access token is not found');
    return null;
  }

  if (isNil(appSyncUrl)) {
    console.error('AppSync URL is not found');
    return null;
  }

  let host: string;

  try {
    host = new URL(appSyncUrl).host;
  } catch (error) {
    captureWebsocketError(error);
    throw new Error('Invalid AppSync URL');
  }

  return {
    Authorization: accessToken,
    host,
  };
};
